/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 에디터가 기본으로 제공하는 내장 블록 클래스들의 레지스트리를 정의한다.
 *
 * @file /src/rootin/base/Blocks.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 7. 26.
 */
import { Block } from '@rootin/base/Block';
import { Editor } from '@rootin/core/Editor';
import { Paragraph } from '@rootin/blocks/paragraph/Paragraph';
import { Heading } from '@rootin/blocks/heading/Heading';
import { Quote } from '@rootin/blocks/quote/Quote';
import { Images } from '@rootin/blocks/images/Images';
import { Callout } from '@rootin/blocks/callout/Callout';
import { List } from '@rootin/blocks/list/List';
import { Table } from '@rootin/blocks/table/Table';
import { Talk } from '@rootin/blocks/talk/Talk';
import { Divider } from '@rootin/blocks/divider/Divider';

export type { Block };

export type BlockClass<T extends Block = Block> = (new (editor: Editor) => T) & typeof Block;

/**
 * 내장 블록 클래스 목록.
 */
const registry: BlockClass[] = [Paragraph, Heading, Quote, Images, Callout, List, Table, Talk, Divider];

export class Blocks {
    /**
     * 블록타입 문자열로 에디터 내장 블록 클래스를 가져온다.
     *
     * @param type - 블록타입
     * @returns 해당 블록 클래스
     */
    static get(type: string): BlockClass {
        const BlockClass = registry.find((BlockClass) => BlockClass.type === type);
        if (BlockClass === undefined) {
            throw new Error(`알 수 없는 블록타입입니다: ${type}`);
        }

        return BlockClass;
    }
}
